import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {inject, observer} from 'mobx-react';
import {mapValues, pick} from 'lodash';

import ToastNotification from './ToastNotification';

import messages from './messages';
import {ToastNotificationsWrapper} from './styles';

@inject('store')
@observer
class ToastNotificationsComponent extends Component {
  componentDidMount = () => {
    const {
      store: {
        platform: {setTranslations}
      },
      intl: {formatMessage}
    } = this.props;

    const translations = mapValues(pick(messages, ['goesOffline', 'goesBackOnline']), message =>
      formatMessage(message)
    );

    setTranslations(translations);
  };

  render() {
    const {
      store: {
        toastNotifications: {notifications}
      },
      isDesktop
    } = this.props;

    return (
      <ToastNotificationsWrapper isDesktop={isDesktop}>
        {notifications.map(notification => (
          <ToastNotification key={notification.id} notification={notification} />
        ))}
      </ToastNotificationsWrapper>
    );
  }
}

export default injectIntl(ToastNotificationsComponent);
